import React, { useEffect, useState } from "react";
import { Button, FormControl, MenuItem, Select, TextField } from "@mui/material";
import BreadCrumb from "../../../../Admin-Dashboard/@components/Breadcrumb";
import Sidebar from "../../../components/Sidebar";
import {
  createWpTableData,
  getParticularWpTableData,
  updateParticularWpTableData,
} from "../../../../Admin-Dashboard/apiHandler/preference.service";
import TextArea from "../../../../Admin-Dashboard/@common/TextArea";
import { setMessage } from "../../../../store/slices/Notification";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

interface FormState {
  movie: string;
  msgType: string;
  name: string;
  header: string;
  headerImage: string;
  footer: string;
  optionKey: string;
  optionKeyMappingText: string;
  templateId: string;
  qrPayload: string;
  buttonUrlParam: string;
  isActive: string;
  isPushed: string;
  numberOfButtons: number;
}

// Utility function to convert label to camelCase
const toCamelCase = (str: string): string =>
  str
    .replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, (match: string, index: number) =>
      index === 0 ? match.toLowerCase() : match.toUpperCase()
    )
    .replace(/\s+/g, "");

const CrateEditFlowForWp: React.FC = () => {
  const [formState, setFormState] = useState<any>({
    name: "",
    header: "",
    headerImage: "",
    footer: "",
    optionKey: "",
    optionKeyMappingText: "",
    templateId: "",
    qrPayload: "",
    buttonUrlParam: "",
    isActive: "false",
    isPushed: "false",
  });

  const navigate = useNavigate();

  const { id } = useParams();
  useEffect(() => {
    if (id) {
      getParticularWpTableData(id).then((res) => {
        setFormState({
          ...res?.data,
          isPushed: res?.data?.isPushed ? "true" : "false",
          isActive: res?.data?.isActive ? "true" : "false",
        });
      });
    }
  }, [id]);

  const handleChange = (key: keyof FormState) => (event: React.ChangeEvent<HTMLInputElement | { value: string }>) => {
    setFormState((prev: any) => ({ ...prev, [key]: event.target.value }));
  };
  const dispatch = useDispatch();

  const onSave = async () => {
    try {
      if (!formState.name) {
        dispatch(setMessage({ type: "error", message: "Name is required" }));
        return;
      }
      if (!formState.body) {
        dispatch(setMessage({ type: "error", message: "Template is required" }));
        return;
      }
      if (!formState.messageType) {
        dispatch(setMessage({ type: "error", message: "Message Type is required" }));
        return;
      }

      if (!formState.communicationType) {
        dispatch(setMessage({ type: "error", message: "Communication Type is required" }));
        return;
      }
      if (!formState.templateLang) {
        dispatch(setMessage({ type: "error", message: "Template Language is required" }));
        return;
      }
      if (!formState.providerType) {
        dispatch(setMessage({ type: "error", message: "Provider Type is required" }));
        return;
      }
      if (id) {
        await updateParticularWpTableData(id, {
          ...formState,
          isActive: formState?.isActive === "false" ? false : true,
          isPushed: formState?.isPushed === "false" ? false : true,
        })
          .then((res: any) => {
            dispatch(setMessage({ type: "success", message: "Template Updated Successfully" }));
          })
          .catch((err) => {
            throw err;
          });
      } else {
        await createWpTableData({
          ...formState,
          isActive: formState?.isActive === "false" ? false : true,
          isPushed: formState?.isPushed === "false" ? false : true,
        });
        dispatch(setMessage({ type: "success", message: "Template Created Successfully" }));
      }
      navigate("/dashboard/user-notification/whatsapp-template");
    } catch (err: any) {
      console.log(">>>>>>>err", err);
      dispatch(setMessage({ type: "error", message: err?.response?.data?.message || "Something went wrong" }));
    }
  };

  return (
    <>
      <div className="flex">
        <Sidebar active_link="/dashboard/whatsapp-template" type="data_collection" title="Dashboard" />
        <div className="pl-8 w-[75%]  dashboard-image mt-20">
          <div className="header-container ">
            <div className="w-full">
              <BreadCrumb
                breadCrumbArray={[
                  {
                    label: "Dashboard",
                    link: "/dashboard",
                  },
                  { label: "Whatsapp Template", link: "/dashboard/user-notification/whatsapp-template" },
                  { label: !id ? "Create" : "Edit", link: "" },

                ]}
              />{" "}
              <div className="flex justify-between w-full">
                <h1 className="title mt-4">{id ? "Edit" : "Create"} Whatsapp Template</h1>
                <Button variant="contained" className="!py-2 !h-[48px] !w-[120px]" onClick={onSave}>
                  Save
                </Button>
              </div>
            </div>
          </div>
          <div className="flex flex-col">
            <div className="grid grid-cols-2 gap-4 my-4">
              <FormControl className="mt-4" fullWidth>
                <label id="msgType-label">Parent Id</label>
                <Select
                  value={(formState?.parentId as any) || ""}
                  onChange={(value, e: any) => {
                    setFormState((prev: any) => ({ ...prev, parentId: e.props.value }));
                  }}
                >
                  <MenuItem value={"Option 1"}>Option 1</MenuItem>
                  <MenuItem value={"Option 2"}>Option 2</MenuItem>
                </Select>
              </FormControl>

              <FormControl className="mt-4" fullWidth>
                <label id="msgType-label">Message Type</label>
                <Select
                  value={(formState?.messageType as any) || ""}
                  onChange={(value, e: any) => {
                    setFormState((prev: any) => ({ ...prev, messageType: e.props.value }));
                  }}
                >
                  <MenuItem value={"TEXT"}>TEXT</MenuItem>
                  <MenuItem value={"HSM"}>HSM</MenuItem>
                  <MenuItem value={"IMAGE"}>IMAGE</MenuItem>
                </Select>
              </FormControl>
              <FormControl className="mt-4" fullWidth>
                <label id="msgType-label">Communication Type</label>
                <Select
                  value={(formState?.communicationType as any) || ""}
                  onChange={(value, e: any) => {
                    setFormState((prev: any) => ({ ...prev, communicationType: e.props.value }));
                  }}
                >
                  <MenuItem value={"COMMUNICATION"}>COMMUNICATION</MenuItem>
                  <MenuItem value={"TRANSACTIONAL"}>TRANSACTIONAL</MenuItem>
                  <MenuItem value={"PROMOTIONAL"}>PROMOTIONAL</MenuItem>
                </Select>
              </FormControl>
              <FormControl className="mt-4" fullWidth>
                <label id="msgType-label">Button Type</label>
                <Select
                  value={(formState?.buttonType as any) || ""}
                  onChange={(value, e: any) => {
                    setFormState((prev: any) => ({ ...prev, buttonType: e.props.value }));
                  }}
                >
                  <MenuItem value={"NONE"}>NONE</MenuItem>
                  <MenuItem value={"CALL_TO_ACTION"}>CALL_TO_ACTION</MenuItem>
                  <MenuItem value={"QUICK_REPLY"}>QUICK_REPLY</MenuItem>
                  <MenuItem value={"QUICK_REPLY_AND_CALL_TO_ACTION"}>QUICK_REPLY_AND_CALL_TO_ACTION</MenuItem>
                </Select>
              </FormControl>
              <FormControl className="mt-4" fullWidth>
                <label id="msgType-label">Category Type</label>
                <Select
                  value={(formState?.categoryType as any) || ""}
                  onChange={(value, e: any) => {
                    setFormState((prev: any) => ({ ...prev, categoryType: e.props.value }));
                  }}
                >
                  <MenuItem value={"UTILITY"}>UTILITY</MenuItem>
                  <MenuItem value={"MARKETING"}>MARKETING</MenuItem>
                </Select>
              </FormControl>
              <FormControl className="mt-4" fullWidth>
                <label id="msgType-label">Template Language</label>
                <Select
                  value={(formState?.templateLang as any) || ""}
                  onChange={(value, e: any) => {
                    setFormState((prev: any) => ({ ...prev, templateLang: e.props.value }));
                  }}
                >
                  <MenuItem value={"HINDI"}>HINDI</MenuItem>
                  <MenuItem value={"ENGLISH"}>ENGLISH</MenuItem>
                </Select>
              </FormControl>
              <FormControl className="mt-4" fullWidth>
                <label id="msgType-label">Provider Type</label>
                <Select
                  value={(formState?.providerType as any) || ""}
                  onChange={(value, e: any) => {
                    setFormState((prev: any) => ({ ...prev, providerType: e.props.value }));
                  }}
                >
                  <MenuItem value={"GUPSHUP"}>GUPSHUP</MenuItem>
                </Select>
              </FormControl>
            </div>
            <div>
              <label>Template</label>
              <TextArea
                placeholder="Enter Template"
                label="Template"
                className="!mb-4"
                value={formState.body}
                handleChange={(e: any) => setFormState({ ...formState, body: e.target.value })}
              />
            </div>

            <div className="my-4">
              <label>Button Meta Data</label>
              <TextArea
                placeholder="Button Meta Data"
                label="Button Meta Data"
                className="!my-4"
                value={formState.buttonMetaData}
                handleChange={(e: any) => setFormState({ ...formState, buttonMetaData: e.target.value })}
              />
            </div>

            <TextField
              className="!my-4"
              type="number"
              key={"Number Of Buttons"}
              label={"Number Of Buttons"}
              value={`${formState["numberOfButtons"]}`}
              onChange={(e) => {
                setFormState((prev: any) => ({ ...prev, numberOfButtons: parseInt(e.target.value) }));
              }}
            />
            <div className="grid grid-cols-2 gap-4 my-4">
              {[
                "Name",
                "Header",
                "Header Image",
                "Footer",
                "Option Key",
                "Option Key Mapping Text",
                "Template Id",
                "Qr Payload",
                "Button Url Param",
              ].map((label) => (
                <div className="flex flex-col">
                  <label>{label}</label>
                  <TextField
                    key={label}
                    value={formState[toCamelCase(label) as keyof FormState]}
                    onChange={handleChange(toCamelCase(label) as keyof FormState)}
                  />
                </div>
              ))}
            </div>

            <FormControl fullWidth className="!mb-4">
              <label id="isActive-label">Status</label>
              <Select
                value={formState.isActive}
                onChange={(value, e: any) => {
                  setFormState((prev: any) => ({ ...prev, isActive: e.props.value }));
                }}
              >
                <MenuItem value={"true"}>Yes</MenuItem>
                <MenuItem value={"false"}>No</MenuItem>
              </Select>
            </FormControl>

            <FormControl fullWidth>
              <label id="isPushed-label">Is Pushed</label>
              <Select
                value={formState.isPushed}
                onChange={(value, e: any) => {
                  setFormState((prev: any) => ({ ...prev, isPushed: e.props.value }));
                }}
              >
                <MenuItem value={"true"}>Yes</MenuItem>
                <MenuItem value={"false"}>No</MenuItem>
              </Select>
            </FormControl>
          </div>
        </div>
      </div>
    </>
  );
};

export default CrateEditFlowForWp;
